<!-- 专利需求发布 -->
<template>
  <div class="container">
    <h1>基础信息</h1>
    <div class="describe">
      <p>专利详情描述</p>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入"
        v-model="form.description"
        resize="none"
      >
      </el-input>
    </div>
    <div class="submit" @click="submitForm">提交</div>
  </div>
</template>

<script>
import {
  getPublishWantToBuy,
  getMyWantToBuyDetail,
  getUpdateWantToBuy,
} from "../../api/userApi";
export default {
  data() {
    return {
      form: {
        id: "",
        description: "",
      },
      isEdit: false, // 是否为编辑模式
    };
  },
  created() {
    this.checkEditMode();
  },
  methods: {
    // 检查是否为编辑模式
    checkEditMode() {
      const id = this.$route.query.id;
      if (id) {
        this.isEdit = true;
        this.fetchDetail(id);
      }
    },
    // 获取详情
    async fetchDetail(id) {
      try {
        const res = await getMyWantToBuyDetail({ id });
        if (res.code === 1 && res.data) {
          this.form = {
            id: res.data.id,
            description: res.data.description,
          };
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },
    async submitForm() {
      if (!this.form.description.trim()) {
        this.$message.error("请输入专利详情描述");
        return;
      }

      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("description", this.form.description);
        let response;
        // 调用接口
        if (this.isEdit) {
          formData.append("id", this.form.id);
          response = await getUpdateWantToBuy(formData);
        } else {
          response = await getPublishWantToBuy(formData);
        }
        if (response.code === 1) {
          this.$message.success(
            response.msg || (this.isEditMode ? "修改成功" : "发布成功")
          );
          this.form.description = "";
          // 如果是编辑模式，返回列表页
          if (this.isEditMode) {
            this.$router.push("/memberCenter/my-publications");
          }
        } else {
          this.$message.error(
            response.msg || (this.isEditMode ? "修改失败" : "发布失败")
          );
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$message.error("提交出错，请稍后重试");
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // align-items: center;
  padding: 20px 35px 56px 20px;
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    text-align: left;
  }
  .describe {
    margin-top: 32px;
    margin-left: 15px;
    border-bottom: 1px solid #dedede;
    padding-bottom: 32px;
    p {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #434343;
      text-align: left;
      margin-bottom: 15px;
    }
    ::v-deep .el-textarea__inner {
      width: 973px;
      height: 83px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #d8d9dc;
      padding: 11px 13px;
    }
    .el-textarea__inner::placeholder {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #b1b1b1;
    }
  }
  .submit {
    width: 83px;
    height: 42px;
    background: #233cac;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    line-height: 42px;
    margin-left: 15px;
    margin-top: 444px;
    cursor: pointer;
  }
}
</style>
